/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSeryRiderInfo = /* GraphQL */ `
  mutation CreateSeryRiderInfo($input: CreateSeryRiderInfoInput!) {
    createSeryRiderInfo(input: $input) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const updateSeryRiderInfo = /* GraphQL */ `
  mutation UpdateSeryRiderInfo($input: UpdateSeryRiderInfoInput!) {
    updateSeryRiderInfo(input: $input) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const deleteSeryRiderInfo = /* GraphQL */ `
  mutation DeleteSeryRiderInfo($input: DeleteSeryRiderInfoInput!) {
    deleteSeryRiderInfo(input: $input) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const createSeryOrderInfos = /* GraphQL */ `
  mutation CreateSeryOrderInfos($inputs: CreateSeryOrderInfosInput!) {
    createSeryOrderInfos(inputs: $inputs) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const createSeryOrderInfo = /* GraphQL */ `
  mutation CreateSeryOrderInfo($input: [CreateSeryOrderInfoInput!]!) {
    createSeryOrderInfo(input: $input) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
    }
  }
`;
export const updateSeryOrderInfo = /* GraphQL */ `
  mutation UpdateSeryOrderInfo($input: UpdateSeryOrderInfoInput!) {
    updateSeryOrderInfo(input: $input) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const deleteSeryOrderInfo = /* GraphQL */ `
  mutation DeleteSeryOrderInfo($input: DeleteSeryOrderInfoInput!) {
    deleteSeryOrderInfo(input: $input) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const createSeryNoti = /* GraphQL */ `
  mutation CreateSeryNoti($input: CreateSeryNotiInput!) {
    createSeryNoti(input: $input) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const updateSeryNoti = /* GraphQL */ `
  mutation UpdateSeryNoti($input: UpdateSeryNotiInput!) {
    updateSeryNoti(input: $input) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const deleteSeryNoti = /* GraphQL */ `
  mutation DeleteSeryNoti($input: DeleteSeryNotiInput!) {
    deleteSeryNoti(input: $input) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const createTeryRecipe = /* GraphQL */ `
  mutation CreateTeryRecipe($input: CreateTeryRecipeInput!) {
    createTeryRecipe(input: $input) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const updateTeryRecipe = /* GraphQL */ `
  mutation UpdateTeryRecipe($input: UpdateTeryRecipeInput!) {
    updateTeryRecipe(input: $input) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const deleteTeryRecipe = /* GraphQL */ `
  mutation DeleteTeryRecipe($input: DeleteTeryRecipeInput!) {
    deleteTeryRecipe(input: $input) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const createTeryRecipeRank = /* GraphQL */ `
  mutation CreateTeryRecipeRank($input: CreateTeryRecipeRankInput!) {
    createTeryRecipeRank(input: $input) {
      searchWord
      searchCount
    }
  }
`;
export const updateTeryRecipeRank = /* GraphQL */ `
  mutation UpdateTeryRecipeRank($input: UpdateTeryRecipeRankInput!) {
    updateTeryRecipeRank(input: $input) {
      searchWord
      searchCount
    }
  }
`;
export const deleteTeryRecipeRank = /* GraphQL */ `
  mutation DeleteTeryRecipeRank($input: DeleteTeryRecipeRankInput!) {
    deleteTeryRecipeRank(input: $input) {
      searchWord
      searchCount
    }
  }
`;
export const createTeryRecipeCategory = /* GraphQL */ `
  mutation CreateTeryRecipeCategory($input: CreateTeryRecipeCategoryInput!) {
    createTeryRecipeCategory(input: $input) {
      regDate
      data
    }
  }
`;
export const updateTeryRecipeCategory = /* GraphQL */ `
  mutation UpdateTeryRecipeCategory($input: UpdateTeryRecipeCategoryInput!) {
    updateTeryRecipeCategory(input: $input) {
      regDate
      data
    }
  }
`;
export const deleteTeryRecipeCategory = /* GraphQL */ `
  mutation DeleteTeryRecipeCategory($input: DeleteTeryRecipeCategoryInput!) {
    deleteTeryRecipeCategory(input: $input) {
      regDate
      data
    }
  }
`;
export const createStoreProductComment = /* GraphQL */ `
  mutation CreateStoreProductComment($input: CreateStoreProductCommentInput!) {
    createStoreProductComment(input: $input) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const updateStoreProductComment = /* GraphQL */ `
  mutation UpdateStoreProductComment($input: UpdateStoreProductCommentInput!) {
    updateStoreProductComment(input: $input) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const deleteStoreProductComment = /* GraphQL */ `
  mutation DeleteStoreProductComment($input: DeleteStoreProductCommentInput!) {
    deleteStoreProductComment(input: $input) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const createStoreQnaInfoTable = /* GraphQL */ `
  mutation CreateStoreQnaInfoTable($input: CreateStoreQnaInfoTableInput!) {
    createStoreQnaInfoTable(input: $input) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const updateStoreQnaInfoTable = /* GraphQL */ `
  mutation UpdateStoreQnaInfoTable($input: UpdateStoreQnaInfoTableInput!) {
    updateStoreQnaInfoTable(input: $input) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const updateNumberParticipants = /* GraphQL */ `
  mutation UpdateNumberParticipants($input: UpdateNumberParticipants!) {
    updateNumberParticipants(input: $input) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const updateReadStoreQnaInfoTable = /* GraphQL */ `
  mutation UpdateReadStoreQnaInfoTable(
    $input: updateReadStoreQnaInfoTableInput!
  ) {
    updateReadStoreQnaInfoTable(input: $input) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const deleteStoreQnaInfoTable = /* GraphQL */ `
  mutation DeleteStoreQnaInfoTable($input: DeleteStoreQnaInfoTableInput!) {
    deleteStoreQnaInfoTable(input: $input) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const createUpdateCheck = /* GraphQL */ `
  mutation CreateUpdateCheck($input: CreateUpdateCheckInput!) {
    createUpdateCheck(input: $input) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const updateUpdateCheck = /* GraphQL */ `
  mutation UpdateUpdateCheck($input: UpdateUpdateCheckInput!) {
    updateUpdateCheck(input: $input) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const deleteUpdateCheck = /* GraphQL */ `
  mutation DeleteUpdateCheck($input: DeleteUpdateCheckInput!) {
    deleteUpdateCheck(input: $input) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const createTeryMarketNoti = /* GraphQL */ `
  mutation CreateTeryMarketNoti($input: CreateTeryMarketNotiInput!) {
    createTeryMarketNoti(input: $input) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const updateTeryMarketNoti = /* GraphQL */ `
  mutation UpdateTeryMarketNoti($input: UpdateTeryMarketNotiInput!) {
    updateTeryMarketNoti(input: $input) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const deleteTeryMarketNoti = /* GraphQL */ `
  mutation DeleteTeryMarketNoti($input: DeleteTeryMarketNotiInput!) {
    deleteTeryMarketNoti(input: $input) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const createBooking = /* GraphQL */ `
  mutation CreateBooking($input: CreateBookingInput!) {
    createBooking(input: $input) {
      booking_idx
      product_fk
      STAFF_FK
      NAME
      STORE_SEQ
      PHONE_NUMBER
      BOOKING_DATE
      START_TIME
      END_TIME
      MEMO
      ETC
    }
  }
`;
export const notifyDuplicateLogin = /* GraphQL */ `
  mutation NotifyDuplicateLogin($storeSeq: String!) {
    notifyDuplicateLogin(storeSeq: $storeSeq) {
      storeSeq
      timestamp
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.js